/*
 * Copyright © 2025 AionTrack. All rights reserved.
 */

import { z } from 'zod'

export const projectSchema = z.object({
  name: z.string().min(1, 'Project name is required').max(100, 'Project name is too long'),
  description: z.string().max(500, 'Description is too long').optional(),
  nle_type: z.enum(['premiere', 'avid', 'resolve', 'final_cut']).optional(),
  timecode_format: z.string().optional(),
})

export type ProjectFormInput = z.infer<typeof projectSchema>
